import useServiceFactory from "../serviceFactory";
const apiUrl = `/catalogos/clientes`;
const useApiClientes = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        guardar: async (params) => service.post(`${apiUrl}`, params),
    }
};

export default useApiClientes;